
import { ReactNode } from "react";
import { Separator } from "@/components/ui/separator";

interface SettingsSectionWrapperProps {
  children: ReactNode;
  isLast?: boolean;
  title?: ReactNode; // Changed from string to ReactNode
}

export const SettingsSectionWrapper = ({ 
  children, 
  isLast = false,
  title
}: SettingsSectionWrapperProps) => {
  return (
    <>
      {title && <h3 className="font-medium text-lg mb-2">{title}</h3>}
      {children}
      {!isLast && <Separator className="bg-digger-blue-light/50" />}
    </>
  );
};
